import React from "react";
import { Reveal } from "./_shared";

export default function FeatureVideo({ data }) {
  if (!data?.enabled || !data?.url) return null;
  return (
    <section
      className="bg-[#1A1A1A] text-[#c3ba9e] py-20 md:py-28 paper-grain"
      data-testid="feature-video-section"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <Reveal className="text-center mb-10 md:mb-14">
          <p className="eyebrow text-[#c3ba9e]/70">{data.eyebrow}</p>
          <h2 className="font-serif-display text-4xl md:text-5xl mt-4 text-[#c3ba9e]">
            {data.heading}
          </h2>
          {data.body && (
            <p className="text-[#c3ba9e]/65 mt-5 max-w-2xl mx-auto leading-relaxed">{data.body}</p>
          )}
        </Reveal>
        <Reveal className="aspect-video overflow-hidden border border-[#c3ba9e]/15">
          <video
            src={data.url}
            poster={data.poster || undefined}
            autoPlay={!!data.autoplay}
            loop={!!data.loop}
            muted={!!data.muted}
            playsInline
            controls
            className="w-full h-full object-cover bg-[#0d0d0e]"
            data-testid="feature-video-player"
          />
        </Reveal>
      </div>
    </section>
  );
}
